var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-animation"},[_c('LottieAnimation',{ref:"lottieAnimation",staticClass:"lottie-image",attrs:{"animation-data":_vm.spinningHub,"auto-play":true,"loop":true,"speed":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }